import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import VenueCategoryCreateEditForm from './Components/VenueCategoryCreateEditForm';
import VenueCategoryApi from './VenueCategoryApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: VenueCategoryCreateEditForm,
                getCreate: VenueCategoryApi.create,
                defaults: {},
                successMessage: "VenueCategory Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}